import { ShieldCheck, Lock } from "lucide-react";

// Credentials band directly under the hero. Leads with the two Oracle
// signals (Partner status + the published OCI reference architecture) to
// reinforce the Oracle-first positioning, then the security/compliance
// credentials a finance buyer screens for.
const TrustStrip = () => {
  return (
    <section
      aria-label="Credentials and certifications"
      className="bg-white border-b border-gray-200"
    >
      <div className="container mx-auto px-4 py-8">
        <p className="text-center text-xs font-semibold uppercase tracking-wider text-gray-400 mb-6">
          Built on Oracle. Secured for finance.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6">
          {/* Oracle Partner */}
          <img
            src="/oracle-partner-logo.png"
            alt="Oracle Partner"
            width={174}
            height={40}
            className="h-10 w-auto"
            loading="lazy"
          />

          <span className="hidden sm:block h-8 w-px bg-gray-200" aria-hidden />

          {/* Oracle Reference Architecture — third-party Oracle validation */}
          <a
            href="https://docs.oracle.com/en/solutions/ez-cloud-on-oci/"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-1.5 text-sm"
          >
            <span className="font-semibold text-gray-900 group-hover:text-primary transition-colors">
              Published on the Oracle Reference Architecture
            </span>
            <span className="text-gray-400 group-hover:text-primary transition-colors">
              for OCI&nbsp;↗
            </span>
          </a>

          <span className="hidden sm:block h-8 w-px bg-gray-200" aria-hidden />

          {/* SOC 2 */}
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <ShieldCheck className="w-5 h-5 text-primary" aria-hidden />
            <span className="font-semibold">SOC 2 Type II</span>
          </div>

          <span className="hidden sm:block h-8 w-px bg-gray-200" aria-hidden />

          {/* Encryption */}
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <Lock className="w-5 h-5 text-primary" aria-hidden />
            <span className="font-semibold">256-bit AES encryption</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustStrip;
